export default __webpack_public_path__ + "static/N0146-93d1545b894eddf70b312ab213eae565.png";